<div class="background-darker">
    <div class="container flex center">
        <div class="flex space-between footer-content w-100">
            <div class="flex column logo-container">
                <img class="logo" src="{{projectLogo}}" alt="logo">
            </div>
			<div class="flex row">
				@for (media of socialMedia; track $index) {
					<button class="bg-primary-darker social-media-btn" mat-icon-button (click)="openLink(media.link)">
						<img [src]="media.logo" [alt]="media.link">
					</button>
				}
				<div class="flex row">
					<app-language-switcher [showAbbreviation]="false" [textColorWhite]="true" [hoverDisabled]="true"></app-language-switcher>
				</div>
			</div>
        </div>
		<hr>
		@if (!isSmallScreen) {
			<div class="flex mt-40 space-between w-100 center">
				<div class="flex column-gap-40">
					<p class="text-accent-lighter m-0">{{'footer.footer_branding'| translateWithKeys}}</p>

				</div>
				<div class="flex column-gap-40 gap">
					<a *hasPermission="[Permissions.VIEW_TERMS_AND_CONDITIONS]" class="terms-link text-accent-lighter" routerLink="/terms-and-conditions">{{'general.terms_and_conditions' | translateWithKeys}}</a>
					<a *hasPermission="[Permissions.VIEW_PRIVACY_POLICY]" class="terms-link text-accent-lighter" routerLink="/privacy-policy">{{'general.privacy_policy' | translateWithKeys}}</a>
					<a *hasPermission="[Permissions.VIEW_REFUND_AND_DELIVERY_POLICY]" class="terms-link text-accent-lighter" routerLink="/refund-and-delivery-policy">{{'general.refund_and_delivery_policy' | translateWithKeys}}</a>

				</div>
			</div>
		} @else {
			<div class="flex column gap pb-20 w-100 center">
				<div class="flex column center gap-8">
					<a *hasPermission="[Permissions.VIEW_TERMS_AND_CONDITIONS]" class="terms-link text-accent-lighter" routerLink="/terms-and-conditions">{{'general.terms_and_conditions' | translateWithKeys}}</a>
					<a *hasPermission="[Permissions.VIEW_PRIVACY_POLICY]" class="terms-link text-accent-lighter" routerLink="/privacy-policy">{{'general.privacy_policy' | translateWithKeys}}</a>
					<a *hasPermission="[Permissions.VIEW_REFUND_AND_DELIVERY_POLICY]" class="terms-link text-accent-lighter" routerLink="/refund-and-delivery-policy">{{'general.refund_and_delivery_policy' | translateWithKeys}}</a>

				</div>
				<div class="flex column-gap-40 ">
					<p class="text-accent-lighter m-0">{{'footer.footer_branding'| translateWithKeys}}</p>
				</div>
			</div>
		}
    </div>
</div>
